import {
  BorderOutlined,
  EyeOutlined,
  FireOutlined,
  ShakeOutlined,
  SoundOutlined,
} from '@ant-design/icons'
import { ExclamationTriangleIcon, InfoCircledIcon } from '@radix-ui/react-icons'
import React from 'react'
import { Department, ObservationType, Severity } from 'types'

type IconType = React.ReactNode

export const severityStyles: Record<
  Severity,
  { color: string; icon: IconType }
> = {
  [Severity.Low]: { color: '#AD7F35', icon: <InfoCircledIcon /> },
  [Severity.Medium]: { color: '#EBC763', icon: <InfoCircledIcon /> },
  [Severity.High]: { color: '#EBB315', icon: <ExclamationTriangleIcon /> },
  [Severity.Critical]: { color: '#EB7715', icon: <ExclamationTriangleIcon /> },
}

export const departmentStyles: Record<Department, { icon?: IconType }> = {
  [Department.PDM]: {},
  [Department.OPERATIONS]: {},
  [Department.ASSET_MANAGEMENT]: {},
}

export const observationTypeStyles: Record<
  ObservationType,
  { icon: IconType }
> = {
  [ObservationType.THERMAL]: { icon: <FireOutlined /> },
  [ObservationType.VISUAL]: { icon: <EyeOutlined /> },
  [ObservationType.ACOUSTIC]: { icon: <SoundOutlined /> },
  [ObservationType.VIBRATIONAL]: { icon: <ShakeOutlined /> },
  [ObservationType.OIL]: { icon: <BorderOutlined /> },
  [ObservationType.INFRARED]: { icon: <EyeOutlined /> },
}
